<div class="grid-fixed">
  <div>
    <h2>{{ 'POLICIES.COOKIES' | mTranslate }}</h2>
    <p class="lightbox-cookies__text">
      {{ 'COOKIES_BOX.TITLE' | mTranslate }}
      <span class="lightbox-cookies__policy" (click)="goToCookiesPage()">{{ 'POLICIES.COOKIES' | mTranslate }}</span
      >{{ 'COOKIES_BOX.SUBTITLE' | mTranslate }}
    </p>
  </div>

  <div class="lightbox-cookies__actions">
    <button m-button buttonType="ghost" (click)="configCookies()">
      {{ 'COOKIES_BOX.CONFIGURATION' | mTranslate }}
    </button>
    <button m-button color="neutral" (click)="rejectCookies()">{{ 'COMMON.REJECT' | mTranslate }}</button>
    <button m-button (click)="acceptCookies()">{{ 'COMMON.ACCEPT' | mTranslate }}</button>
  </div>
</div>
